export const EXPIRED_EXTEND_TRIAL_GET = 'EXPIRED_EXTEND_TRIAL_GET'
export const EXPIRED_EXTEND_TRIAL_UPDATE = 'EXPIRED_EXTEND_TRIAL_UPDATE'
export const EXPIRED_EXTEND_TRIAL_ERROR = 'EXPIRED_EXTEND_TRIAL_ERROR'

export function getExpiredExtendTrial(payload = {}) {
  return {
    type: EXPIRED_EXTEND_TRIAL_GET,
    payload,
  }
}

export function updateExpiredExtendTrial(payload = {}) {
  return {
    type: EXPIRED_EXTEND_TRIAL_UPDATE,
    payload,
  }
}

export function errorExpiredExtendTrial(payload = {}) {
  return {
    type: EXPIRED_EXTEND_TRIAL_ERROR,
    payload,
  }
}
